import React from "react";
import styles from "./Experience.module.css";

const Experience = () => {
  return (
    <section id="exp" className={styles.container}>
      <div className={styles.experience__box}>
        <h1>300+</h1>
        <h4>Projects Completed</h4>
      </div>
      <p>•</p>
      <div className={styles.experience__box}>
        <h1>3+</h1>
        <h4>Years Experience</h4>
      </div>
      <p>•</p>
      <div className={styles.experience__box}>
        <h1>12K+</h1>
        <h4>Students Trained</h4>
      </div>
      <p>•</p>
      <div className={styles.experience__box}>
        <h1>150+</h1>
        <h4>Happy Clients</h4>
      </div>
    </section>
  );
};

export default Experience;
